export default __webpack_public_path__ + "static/media/Manrope-Light.182f890e.ttf";